module.exports = __webpack_public_path__ + "imagesYagesyaa/images/statistics.454b40a7.png";